import Spinner from "@/features/shared/components/spinner";
import { appTitleHead } from "@/lib/app-document-title";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useAuth } from "oidc-react";
import { useEffect } from "react";

export const Route = createFileRoute("/callback")({
  head: () => appTitleHead("login"),
  component: CallbackPage
});

function CallbackPage() {
  const navigate = useNavigate();
  const { isLoading } = useAuth();

  useEffect(() => {
    if (isLoading) return;

    const returnPath = localStorage.getItem("goBackUrl");
    if (returnPath) {
      void navigate({ href: returnPath });
      return;
    }
    void navigate({ to: "/" });
  }, [navigate, isLoading]);

  return (
    <div className="relative h-screen w-full backdrop-opacity-50">
      <div className="ml-4 h-full w-full">
        <Spinner />
      </div>
    </div>
  );
}
